import * as THREE from 'three';

import {
  // triangleMiddle,
  // triangleSides,
  mergeDeep, getCenterOfPoints, getEndpoints, 
  //addDistanceLabel
} from '../../../services/helper.service';

import { createArrow } from '../../services/helper';

import AbstractGenerator from '../../misc/generator';

import Ground, { LabelsPadding } from '../../objects/ground';
import Panel, { setPanelVerticesCount, setPanelVertices, setPanelType } from '../../objects/panel';
import { Screw, ScrewGroup } from '@scene/objects/screw';
import Beam from '../../objects/beam';
import Arrow from '../../objects/arrow';
import ArrowCurve from '../../objects/arrow-curve';
import { HTMLEditableLabel, HTMLLabel } from '../../objects/html-label';
import { defaultUnits } from '@config';
import { unitTransform } from '../../../services/helper.service';

import Scene from '@scene';
import { APP_TEXTS } from '@texts';
import { setScrewCustomPositions } from '@scene/objects/screw/screw-group';
import Line from '@scene/objects/line';

export default class GeneralCalculationObject extends AbstractGenerator {

  constructor(options = {}) {
    super(options);

    this.isBracket = options.isBracket;
    if (this.options.screw.count.n === 3 || this.options.screw.count.n === 2) {
      this.options.panel.circleCorrection = -90;
    }
  }

  setOrientation() {
    super.setOrientation();

    if (this.is2DMode || this.is2DEditorMode) {
      this.layer2D.mesh.rotation.z = Math.PI / 2;
      // this.layer2D.mesh.rotation.y = Math.PI;
    } else if (this.is3DMode) {
      // this.layer3D.mesh.rotation.y = Math.PI / 2;
      // this.layer3D.mesh.rotation.z = Math.PI / 2;
      switch (this.options.orientation) {
        case AbstractGenerator.orientation.X_INVERT: {
          this.layer3D.mesh.rotation.x = Math.PI / 2;
          this.layer3D.mesh.rotation.y = -Math.PI / 2;
          break;
        }
        case AbstractGenerator.orientation.Y: {
          break;
        }
        case AbstractGenerator.orientation.Y_INVERT: {
          this.layer3D.mesh.rotation.x = Math.PI / 2;
          this.layer3D.mesh.rotation.z = 0;
          break;
        }
        case AbstractGenerator.orientation.X:
        default: {
          this.layer3D.mesh.rotation.y = Math.PI / 2;
          this.layer3D.mesh.rotation.z = Math.PI / 2;
          break;
        }
      }

      this.setHTMLOrientation();
    }
  }

  setHTMLOrientation() {
    super.setHTMLOrientation();
    if (this.is3DMode) {
      switch (this.options.orientation) {
        case AbstractGenerator.orientation.X_INVERT: {
          // move html elements
          for (let i = 0; i < this.layer3D.htmlLayer.htmlLayerElements.length; i++){
            let elem = this.layer3D.htmlLayer.htmlLayerElements[i];
            elem.position.applyAxisAngle(new THREE.Vector3(0, 0, 1), -Math.PI / 2);
          }
          break;
        }
        case AbstractGenerator.orientation.Y: {
          break;
        }
        case AbstractGenerator.orientation.Y_INVERT: {
          // move html elements
          for (let i = 0; i < this.layer3D.htmlLayer.htmlLayerElements.length; i++){
            let elem = this.layer3D.htmlLayer.htmlLayerElements[i];
            elem.position.applyAxisAngle(new THREE.Vector3(0, 0, 1), -Math.PI / 4);
            // if (elem.dirStart && elem.dirEnd) {
            //   elem.dirStart.applyAxisAngle(new THREE.Vector3(0, 0, 1), -Math.PI / 4);
            //   elem.dirEnd.applyAxisAngle(new THREE.Vector3(0, 0, 1), -Math.PI / 4);
            // }
          }
          break;
        }
        case AbstractGenerator.orientation.X:
        default: {
          // move html elements
          // for (let i = 0; i < this.layer3D.htmlLayer.htmlLayerElements.length; i++){
          //   let elem = this.layer3D.htmlLayer.htmlLayerElements[i];
          //   elem.position.applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 4);
          // }
          break;
        }
      }
    }
  }

  init3DObject() {
    this.panel = this.getPanel();
    this.layer3D.addObject(this.panel);

    this.generateScrewGroup();
    // screw labels
    if (!this.options.panel.animate.move.x.active && !this.options.panel.animate.move.y.active && 
      !this.options.panel.animate.move.z.active && !this.options.panel.animate.rotate.x.active && 
      !this.options.panel.animate.rotate.y.active && !this.options.panel.animate.rotate.z.active) 
    {
      const screwLabels = this.screwGroup.getScrewLabels();
      screwLabels.htmlLayer.htmlLayerElements.forEach((htmlElem) => { 
        htmlElem.position.applyAxisAngle(new THREE.Vector3(0, 1, 0), Math.PI / 2);
        htmlElem.position.y += this.screwGroup.options.heightOffset / 2; 
      });
      this.layer3D.addObject(screwLabels);
    }

    // infinite loop
    // if (!this.options.screw.custom.active && 
    //   JSON.stringify(this.panel.screwCoordinates) !== JSON.stringify(this._options.screw.custom.positions)){
    //     this._options.screw.custom.positions = this.panel.screwCoordinates;
    //     this.dispatchOptionUpdate({
    //       screw: {
    //         custom: {
    //           positions: this.panel.screwCoordinates
    //         }
    //       }
    //     });
    // }

    this.beam = this.getBeam(this.options.beam, this.panel);
    this.panel.object.addObject(this.beam);

    this.ground = this.getGround();
    this.layer3D.addObject(this.ground);

    if (this.options.object.dimensions.display) {
      this.addLabels();
    }
    
    if (!this.isBracket)
      this.animatePanel();
  }

  init2DObject() {
    this.panel = this.getPanel(this.options.panel);
    this.layer2D.addObject(this.panel);

    this.generateScrewGroup();

    if (!this.isBracket){
      if (this.panel.type === Panel.types.CUSTOM) {
        const verticesLabels = this.panel.getVerticesLabels(false);
        this.layer2D.addObject(verticesLabels);
      }
    }
    
    const screwLabels = this.screwGroup.getScrewLabels();
    this.layer2D.addObject(screwLabels);

    // VladP: moved the creation of the ground, so we could use the ground padding in our spacing labels
    this.ground = this.getGround();
    this.layer2D.addObject(this.ground);

    const { compressionLine } = this.panel.getCompressionLine();
    if (compressionLine) {
      this.layer2D.addObject(compressionLine);
      let zonesLayer = this.panel.createZonesLabels();
      if (zonesLayer)
        this.layer2D.addLayer(zonesLayer);
    }

    // if (this.screwGroup.isCustom) {
    //   this.options.screw.custom.positions = this.screwGroup.screwCoordinates;
    // }

    this.beam = this.getBeam(this.options.beam, this.panel);
    this.panel.object.addObject(this.beam);

    this.addLabels();
  }

  init2DEditorObject() {
    this.panel = this.getPanel(this.options.panel);
    this.layer2D.addObject(this.panel);
    
    if (this.panel.type !== Panel.types.CIRCLE) {
      const vertices = this.panel.getVerticesLabels(true);
      // the positions are not set in this.options.panel.vertices.positions when the the plate is reset to a standard plate
      var verticesPos = this.panel.options.vertices.positions;
      // when the plate is reset to a standard plate, the count variable is set to ignore the positions vector and generate coords
      var mustUpdateVerticesCount = this.panel.options.vertices.count > 0;
      var panelType = this.panel.type;
      for (let i = 0; i < vertices.length; i++) {
        this.layer2D.htmlLayer.add(vertices[i].htmlObject);
        this.layer2D.addMesh(vertices[i].mesh);
        vertices[i].options.hideHTMLObjectOnHover = true;
        vertices[i].options.onDragEnd = (obj) => {
          verticesPos[i].y = Math.round(verticesPos[i].y - (obj.startPosition.y - obj.endPosition.y));
          verticesPos[i].z = Math.round(verticesPos[i].z + (obj.startPosition.z - obj.endPosition.z));
          if (mustUpdateVerticesCount) 
            setPanelVerticesCount(0, true);
          if (panelType !== Panel.types.CUSTOM)
            setPanelType(Panel.types.CUSTOM, true);
          
          setPanelVertices(verticesPos, false);
        };
        
        this.draggableObjects.push(vertices[i]);
      }
    }
    
    this.generateScrewGroup();
    const screws = this.screwGroup.getScrewLabels(true);
    var screwsPos = this.screwGroup.screwCoordinates;
    for (let i = 0; i < screws.length; i++) {
      this.layer2D.htmlLayer.add(screws[i].htmlObject);
      // this.layer2D.addMesh(screws[i].mesh);
      screws[i].options.hideHTMLObjectOnHover = true;
      screws[i].options.onDragEnd = (obj) => {
        screwsPos[i].y = Math.round(screwsPos[i].y - (obj.startPosition.y - obj.endPosition.y));
        screwsPos[i].z = Math.round(screwsPos[i].z - (obj.startPosition.z - obj.endPosition.z));
        setScrewCustomPositions(screwsPos, false);
      };
      
      this.draggableObjects.push(screws[i]);
    }

    if (this.screwGroup.isCustom) {
      this.options.screw.custom.positions = this.screwGroup.screwCoordinates;
    }

    this.beam = this.getBeam(this.options.beam, this.panel);
    this.panel.object.addObject(this.beam);
  }

  
  addLabels() {
    const layer = this.is3DMode ? this.layer3D : this.layer2D;
    let options = null;
    if (this.is3DMode) {
      options = {
        is3DMode: true,
        rotation: this.layer3D.mesh.rotation,
        showLabels: this.options.object.dimensions.showLabels,
        displayHorizontally: this.options.object.dimensions.displayHorizontally
      };
      
      // Stand off dimension (only in 3D mode)
      if (this.options.screw.heightType === Screw.types.height.INDENTED) {
        const heightLabel = this.getHeightLabel(options);

        layer.addObject(heightLabel.arrow);
        layer.htmlLayer.add(heightLabel.label);
      }
    }

    // Create panel depth label
    var panelDepth;
    if (this.is3DMode) {
      panelDepth = this.panel.create3DDepthLabel(options);
      layer.addMesh(panelDepth.object);
    } else {
      panelDepth = this.panel.createDepthLabel();
    }
    layer.htmlLayer.add(panelDepth.htmlElement);

    if (this.options.panel.type !== Panel.types.CUSTOM){
      // Create width label
      const { line: widthLine, htmlElement: widthHtmlElement } = this.panel.createWidthLabel(options);
      layer.addMesh(widthLine);
      layer.htmlLayer.add(widthHtmlElement);
    }

    // For not CIRCLE panel type
    // VladP: Since we now have the editor, there could be a circle panel with another screw formation
    //if (this.options.screw.formation !== ScrewGroup.formation.CIRCLE 
    if (this.options.panel.type !== Panel.types.CIRCLE && 
      this.options.panel.type !== Panel.types.CUSTOM) { 
      // Create height label
      const { line: heightLine, htmlElement: heightHtmlElement } = this.panel.createHeightLabel(options);
      layer.addMesh(heightLine);
      layer.htmlLayer.add(heightHtmlElement);
    } 
    if (!this.options.screw.customLayout && 
        this.options.screw.formation === ScrewGroup.formation.CIRCLE) {
      const { object: circleObject, htmlElement: circleHtmlElement } = this.screwGroup.createScrewCircle(options);
      layer.addMesh(circleObject);
      layer.htmlLayer.add(circleHtmlElement);
    }

    if (!this.options.screw.customLayout && // plate editor
      (this.options.screw.formation === ScrewGroup.formation.FILLED_SQUARE ||
        this.options.screw.formation === ScrewGroup.formation.EMPTY_SQUARE ||
        this.options.screw.formation === ScrewGroup.formation.NOT_SET) &&
      !this.options.screw.custom.active // custom coords from dimension tab
    ) {
      // Create S1 label
      if (this.options.screw.count.n > 1) {
        const { object: s1Object, htmlElement: s1HtmlElement } = 
          this.panel.createS1Label(
            this.screwGroup, true, this.ground.groundPadding.top + LabelsPadding, null, options
          );
        if (s1HtmlElement && s1Object) {
          layer.addMesh(s1Object);
          layer.htmlLayer.add(s1HtmlElement);
        }
      }

      if (this.options.screw.count.m > 1) {
        const { object: s2Object, htmlElement: s2HtmlElement } = 
          this.panel.createS2Label(
            this.screwGroup, true, this.ground.groundPadding.right + LabelsPadding, null, options
          );
        if (s2HtmlElement && s2Object) {
          layer.addMesh(s2Object);
          layer.htmlLayer.add(s2HtmlElement);
        }
      }
    }

    if (this.options.screw.formation === ScrewGroup.formation.TRIANGLE) {
      const s = this.screwGroup.createSLabel(this.ground.groundPadding, options);

      if (s && s.htmlElement && s.object) {
        layer.addMesh(s.object);
        layer.htmlLayer.add(s.htmlElement);
      }
    }
    
    const shiftLabels = this.beam.createShiftLabels(options);
    if (this.is3DMode && 
      !this.options.panel.animate.move.x.active && !this.options.panel.animate.move.y.active && 
      !this.options.panel.animate.move.z.active && !this.options.panel.animate.rotate.x.active && 
      !this.options.panel.animate.rotate.y.active && !this.options.panel.animate.rotate.z.active) 
    {
      layer.htmlLayer.addLayer(shiftLabels.HTMLLayer);
    }

    const { edgesObject } = this.ground.getEdgeDistanceLabels(options);
    layer.addObject(edgesObject);
    //layer.htmlLayer.addLayer(groundEdgaDistanceLabes.htmlElement);

    const groundDepthLabel = this.ground.getDepthLabel(options);
    if (this.is3DMode && (this.isBracket || this.options.orientation === AbstractGenerator.orientation.Y_INVERT)) {
      // switch thickness side
      groundDepthLabel.htmlElement.position.z *= -1;
      groundDepthLabel.htmlElement.dirStart.z *= -1;
      groundDepthLabel.htmlElement.dirEnd.z *= -1;
      groundDepthLabel.object.rotation.z = -Math.PI;
      groundDepthLabel.object.position.x = this.ground.options.depth;
    }
    // layer.addObject(groundDepthLabel.object);
    layer.htmlLayer.add(groundDepthLabel.htmlElement);
  }

  animatePanel () {
    const RED = 0xff0000;
    const RED_HTML = "#ff0000";
    const GREEN = 0x00ff00;
    const GREEN_HTML = "#00ff00";
    const BLUE = 0x00FFFF;//0x40E0D0;
    const BLUE_HTML = "#00FFFF";//"#40E0D0";

    const arrowSize = 50; //this.beam.height || 100;
    const height = 200;

    if (!this.options.panel.animate)
      return;

    // beam offset and plate center (for 3D editor)
    let offsetX = this.options.beam.shift.x - this.options.panel.center.x;
    let offsetY = this.options.beam.shift.y + this.options.panel.center.y;

    let arrowSizeRotationMx = this.ground.groundPadding.left - offsetX + 2 * LabelsPadding;
    let arrowSizeRotationMy = this.ground.groundPadding.bottom - offsetY + 2 * LabelsPadding;
    let arrowSizeRotationMz = height;
    if (this.options.panel.animate.move.z.active || this.options.panel.animate.move.z.fixed) {
      let value = unitTransform(+this.options.panel.animate.move.z.value).from(defaultUnits.LOAD).to(Scene.units.load);
      let label;
      if (this.options.object.loads.editable) {
        label = new HTMLEditableLabel({
          text: `Nz: ${value} ${this.options.panel.animate.move.z.units || ''}`,
          value: value,
          color: RED_HTML,
          verticalAlign: HTMLLabel.types.verticalAlign.CENTER,
          align: HTMLLabel.types.align.CENTER,
          bold: true,
          initialState: this.options.panel.animate.move.z.labelState || HTMLEditableLabel.states.LABEL
        });
        label.onInputChange((val, didChange) => {
          this.dispatchOptionUpdate({
            panel: {
              loads: {
                Nz: unitTransform(+val, false).from(Scene.units.load).to(defaultUnits.LOAD) 
              },
              animate: {
                move: {
                  z: {
                    labelState: HTMLEditableLabel.states.LABEL,
                    active: false,
                    fixed: true, //!!+val,
                    value: unitTransform(+val, false).from(Scene.units.load).to(defaultUnits.LOAD)
                  }
                }
              }
            }
          },
          false,
          didChange);
        });
        label.onLabelClick(() => {
          this.dispatchOptionUpdate({
            panel: {
              animate: {
                move: {
                  z: {
                    labelState: HTMLEditableLabel.states.INPUT,
                    active: true
                  }
                }
              }
            }
          });
        });
      } else {
        label = {
          prefix: 'Nz',
          value,
          postfix: this.options.panel.animate.move.z.units,
          color: 'red',
        };
      }
      let arrowPosX = (height + arrowSize / 2 + LabelsPadding) * (this.options.panel.animate.move.z.value < 0 ? -1 : 1);
      let dashedLineNz = createDashedLine(
        new THREE.Vector3(
          this.options.panel.animate.move.z.value < 0 ? 0 : arrowSizeRotationMz,
          -offsetX, 
          -offsetY),
        new THREE.Vector3(arrowPosX, -offsetX, -offsetY),
        RED
      );
      this.layer3D.addMesh(dashedLineNz.mesh);
      animate.call(this, {
        animation: {
          isActive: this.options.panel.animate.move.z.active,
          func: this.options.panel.animate.move.z.value < 0 ? this.panel.animate.move.negativeX : this.panel.animate.move.x
        },
        arrow: {
          object: createArrow(
            this.options.panel.animate.move.z.value < 0 ? Arrow.types.direction.NegativeX : Arrow.types.direction.X, 
            true, 
            { 
              color: RED, 
              size: arrowSize, 
              position: new THREE.Vector3(arrowPosX, -offsetX, -offsetY)}
          ),
          activeAxis: 'x'
        },
        label
      });
    }

    if (this.options.panel.animate.move.x.active || this.options.panel.animate.move.x.fixed) {
      let value = unitTransform(+this.options.panel.animate.move.x.value).from(defaultUnits.LOAD).to(Scene.units.load);
      let label;
      if (this.options.object.loads.editable) {
        label = new HTMLEditableLabel({
          text: `Vx: ${value} ${this.options.panel.animate.move.x.units || ''}`,
          value: value,
          color: BLUE_HTML,
          verticalAlign: HTMLLabel.types.verticalAlign.CENTER,
          align: HTMLLabel.types.align.CENTER,
          bold: true,
          initialState: this.options.panel.animate.move.x.labelState || HTMLEditableLabel.states.LABEL
        });
        label.onInputChange((val, didChange) => {
          this.dispatchOptionUpdate({
            panel: {
              loads: {
                Vx: unitTransform(+val, false).from(Scene.units.load).to(defaultUnits.LOAD) 
              },
              animate: {
                move: {
                  x: {
                    labelState: HTMLEditableLabel.states.LABEL,
                    active: false,
                    fixed: true, //!!+val,
                    value: unitTransform(+val, false).from(Scene.units.load).to(defaultUnits.LOAD)
                  }
                }
              }
            }
          },
          false,
          didChange);
        });
        label.onLabelClick(() => {
          this.dispatchOptionUpdate({
            panel: {
              animate: {
                move: {
                  x: {
                    labelState: HTMLEditableLabel.states.INPUT,
                    active: true
                  }
                }
              }
            }
          });
        });
      } else {
        label = {
          prefix: 'Vx',
          value,
          postfix: this.options.panel.animate.move.x.units,
          color: BLUE_HTML,
        };
      }
      let arrowPosY = (this.options.panel.animate.move.x.value < 0 ? 
        (this.ground.groundPadding.right + arrowSize / 2 + 3 * LabelsPadding) : 
        (-this.ground.groundPadding.left - arrowSize / 2 - 4 * LabelsPadding)
      );
      let dashedLineVx = createDashedLine(
        new THREE.Vector3(
          0, 
          this.options.panel.animate.move.x.value < 0 ? 0 : -arrowSizeRotationMx,
          -offsetY),
        new THREE.Vector3(0, arrowPosY, -offsetY),
        BLUE
      );
      this.layer3D.addMesh(dashedLineVx.mesh);
      animate.call(this, {
        animation: {
          isActive: this.options.panel.animate.move.x.active,
          func: this.options.panel.animate.move.x.value < 0 ? this.panel.animate.move.negativeY : this.panel.animate.move.y
        },
        arrow: {
          object: createArrow(this.options.panel.animate.move.x.value < 0 ? Arrow.types.direction.NegativeY : Arrow.types.direction.Y,
            true, 
            { 
              color: BLUE, 
              size: arrowSize, 
              position: new THREE.Vector3(
                0, 
                arrowPosY, 
                -offsetY) 
            }),
          activeAxis: 'y'
        },
        label
      });
    }

    if (this.options.panel.animate.move.y.active || this.options.panel.animate.move.y.fixed) {
      let value = unitTransform(+this.options.panel.animate.move.y.value).from(defaultUnits.LOAD).to(Scene.units.load);
      let label;
      if (this.options.object.loads.editable) {
        label = new HTMLEditableLabel({
          text: `Vy: ${value} ${this.options.panel.animate.move.y.units || ''}`,
          value: value,
          color: GREEN_HTML,
          verticalAlign: HTMLLabel.types.verticalAlign.CENTER,
          align: HTMLLabel.types.align.CENTER,
          bold: true,
          initialState: this.options.panel.animate.move.y.labelState || HTMLEditableLabel.states.LABEL
        });
        label.onInputChange((val, didChange) => {
          this.dispatchOptionUpdate({
            panel: {
              loads: {
                Vy: unitTransform(+val, false).from(Scene.units.load).to(defaultUnits.LOAD) 
              },
              animate: {
                move: {
                  y: {
                    labelState: HTMLEditableLabel.states.LABEL,
                    active: false,
                    fixed: true, //!!+val,
                    value: unitTransform(+val, false).from(Scene.units.load).to(defaultUnits.LOAD)
                  }
                }
              }
            }
          },
          false,
          didChange);
        });
        label.onLabelClick(() => {
          this.dispatchOptionUpdate({
            panel: {
              animate: {
                move: {
                  y: {
                    labelState: HTMLEditableLabel.states.INPUT,
                    active: true
                  }
                }
              }
            }
          });
        });
      } else {
        label = {
          prefix: 'Vy',
          value,
          postfix: this.options.panel.animate.move.y.units,
          color: GREEN_HTML,
        };
      }
    
      let arrowPosZ = (this.options.panel.animate.move.y.value < 0 ? 
        (this.ground.groundPadding.top + arrowSize / 2 + 3 * LabelsPadding) : 
        (-this.ground.groundPadding.bottom - arrowSize / 2 - 4 * LabelsPadding)
      );
      let dashedLineVy = createDashedLine(
        new THREE.Vector3(
          0, 
          -offsetX, 
          this.options.panel.animate.move.y.value < 0 ? 0 : -arrowSizeRotationMy),
        new THREE.Vector3(0, -offsetX, arrowPosZ),
        GREEN
      );
      this.layer3D.addMesh(dashedLineVy.mesh);
      animate.call(this, {
        animation: {
          isActive: this.options.panel.animate.move.y.active,
          func: this.options.panel.animate.move.y.value < 0 ? this.panel.animate.move.negativeZ : this.panel.animate.move.z
        },
        arrow: {
          object: createArrow(
            this.options.panel.animate.move.y.value < 0 ? Arrow.types.direction.NegativeZ : Arrow.types.direction.Z, 
            true, 
            { 
              color: GREEN, 
              size: arrowSize, 
              position: new THREE.Vector3(
                0, 
                -offsetX, 
                arrowPosZ) 
            }),
          activeAxis: 'z'
        },
        label
      });
    }

    if (this.options.panel.animate.rotate.x.active || this.options.panel.animate.rotate.x.fixed) {
      let value = unitTransform(+this.options.panel.animate.rotate.x.value).from(defaultUnits.MOMENT).to(Scene.units.moment);
      let label;
      if (this.options.object.loads.editable) {
        label = new HTMLEditableLabel({
        text: `Mx: ${value} ${this.options.panel.animate.rotate.x.units || ''}`,
        value: value,
        color: BLUE_HTML,
        verticalAlign: HTMLLabel.types.verticalAlign.CENTER,
        align: HTMLLabel.types.align.CENTER,
        bold: true,
        initialState: this.options.panel.animate.rotate.x.labelState || HTMLEditableLabel.states.LABEL
      });
      label.onInputChange((val, didChange) => {
        this.dispatchOptionUpdate({
          panel: {
            loads: {
              Mx: unitTransform(+val, false).from(Scene.units.moment).to(defaultUnits.MOMENT) 
            },
            animate: {
              rotate: {
                x: {
                  labelState: HTMLEditableLabel.states.LABEL,
                  active: false,
                  fixed: true, //!!+val,
                  value: unitTransform(+val, false).from(Scene.units.moment).to(defaultUnits.MOMENT)
                }
              }
            }
          }
        },
        false,
        didChange);
      });
      label.onLabelClick(() => {
        this.dispatchOptionUpdate({
          panel: {
            animate: {
              rotate: {
                x: {
                  labelState: HTMLEditableLabel.states.INPUT,
                  active: true
                }
              }
            }
          }
        });
      });
    } else {
      label = {
        prefix: 'Mx',
        value,
        postfix: this.options.panel.animate.rotate.x.units,
        color: BLUE_HTML,
      };
    }
      animate.call(this, {
        animation: {
          isActive: this.options.panel.animate.rotate.x.active,
          func:  this.options.panel.animate.rotate.x.value < 0 ? this.panel.animate.rotate.negativeY : this.panel.animate.rotate.y
        },
        arrow: {
          object: createCurveArrow(ArrowCurve.types.direction.Y, 
            this.options.panel.animate.rotate.x.value < 0 ? true : false, arrowSizeRotationMx, BLUE, 
            new THREE.Vector3(0, -offsetX, -offsetY)),
          activeAxis: 'y'
        },
        label
      });
    }

    if (this.options.panel.animate.rotate.y.active || this.options.panel.animate.rotate.y.fixed) {
      let value = unitTransform(+this.options.panel.animate.rotate.y.value).from(defaultUnits.MOMENT).to(Scene.units.moment);
      let label;
      if (this.options.object.loads.editable) {
        label = new HTMLEditableLabel({
        text: `My: ${value} ${this.options.panel.animate.rotate.y.units || ''}`,
        value: value,
        color: GREEN_HTML,
        verticalAlign: HTMLLabel.types.verticalAlign.CENTER,
        align: HTMLLabel.types.align.CENTER,
        bold: true,
        initialState: this.options.panel.animate.rotate.y.labelState || HTMLEditableLabel.states.LABEL
      });
      label.onInputChange((val, didChange) => {
        this.dispatchOptionUpdate({
          panel: {
            loads: {
              My: unitTransform(+val, false).from(Scene.units.moment).to(defaultUnits.MOMENT) 
            },
            animate: {
              rotate: {
                y: {
                  labelState: HTMLEditableLabel.states.LABEL,
                  active: false,
                  fixed: true, //!!+val,
                  value: unitTransform(+val, false).from(Scene.units.moment).to(defaultUnits.MOMENT)
                }
              }
            }
          }
        },
        false,
        didChange);
      });
      label.onLabelClick(() => {
        this.dispatchOptionUpdate({
          panel: {
            animate: {
              rotate: {
                y: {
                  labelState: HTMLEditableLabel.states.INPUT,
                  active: true
                }
              }
            }
          }
        });
      });
    } else {
      label = {
        prefix: 'My',
        value,
        postfix: this.options.panel.animate.rotate.y.units,
        color: GREEN_HTML,
      };
    }
      animate.call(this, {
        animation: {
          isActive: this.options.panel.animate.rotate.y.active,
          func: this.options.panel.animate.rotate.y.value < 0 ? this.panel.animate.rotate.negativeZ : this.panel.animate.rotate.z
        },
        arrow: {
          object: createCurveArrow(ArrowCurve.types.direction.Z, 
            this.options.panel.animate.rotate.y.value < 0 ? true : false, arrowSizeRotationMy, GREEN, 
            new THREE.Vector3(0, -offsetX, -offsetY)),
          activeAxis: 'z'
        },
        label
      });
    }

    if (this.options.panel.animate.rotate.z.active || this.options.panel.animate.rotate.z.fixed) {
      let value = unitTransform(+this.options.panel.animate.rotate.z.value).from(defaultUnits.MOMENT).to(Scene.units.moment);
      let label;
      if (this.options.object.loads.editable) {
        label = new HTMLEditableLabel({
          text: `Mz: ${value} ${this.options.panel.animate.rotate.z.units || ''}`,
          value: value,
          color: RED_HTML,
          verticalAlign: HTMLLabel.types.verticalAlign.CENTER,
          align: HTMLLabel.types.align.CENTER,
          bold: true,
          initialState: this.options.panel.animate.rotate.z.labelState || HTMLEditableLabel.states.LABEL
        });
        label.onInputChange((val, didChange) => {
          this.dispatchOptionUpdate({
            panel: {
              loads: {
                Mz: unitTransform(+val, false).from(Scene.units.moment).to(defaultUnits.MOMENT) 
              },
              animate: {
                rotate: {
                  z: {
                    labelState: HTMLEditableLabel.states.LABEL,
                    active: false,
                    fixed: true, //!!+val,
                    value: unitTransform(+val, false).from(Scene.units.moment).to(defaultUnits.MOMENT)
                  }
                }
              }
            }
          },
          false,
          didChange);
        });
        label.onLabelClick(() => {
          this.dispatchOptionUpdate({
            panel: {
              animate: {
                rotate: {
                  z: {
                    labelState: HTMLEditableLabel.states.INPUT,
                    active: true
                  }
                }
              }
            }
          });
        });
      } else {
        label = {
          prefix: 'Mz',
          value,
          postfix: this.options.panel.animate.rotate.z.units,
          color: 'red',
        };
      }
      animate.call(this, {
        animation: {
          isActive: this.options.panel.animate.rotate.z.active,
          func: this.options.panel.animate.rotate.z.value < 0 ? this.panel.animate.rotate.x : this.panel.animate.rotate.negativeX
        },
        arrow: {
          object: createCurveArrow(ArrowCurve.types.direction.X, 
            this.options.panel.animate.rotate.z.value < 0 ? true : false, arrowSizeRotationMz, RED, 
            new THREE.Vector3(0, -offsetX, -offsetY)),
          activeAxis: 'x'
        },
        label
      });
    }

    function animate({ arrow, label, animation }) {
      const arrowObject = arrow.object;
      this.layer3D.addMesh(arrowObject.mesh);

      if (label) {
        let labelObject;
        if (this.options.object.loads.editable) {
          labelObject = label;
        } else {
          labelObject = new HTMLLabel({
            text: `${label.prefix}: ${label.value} ${label.postfix || ''}`,
            color: label.color,
            verticalAlign: HTMLLabel.types.verticalAlign.CENTER,
            align: HTMLLabel.types.align.CENTER,
            bold: true
          });
        }

        const position = arrowObject.directionPosition.clone();

        // Add margin
        if (arrow.activeAxis === 'x') {
          position[arrow.activeAxis] += arrow.object.direction === "-" + arrow.activeAxis ? -20 : 20;
        } else {
          position[arrow.activeAxis] += arrow.object.direction === "-" + arrow.activeAxis ? 20 : -20;
        }

        labelObject.position.set(position.z, position.x, position.y);

        this.layer3D.htmlLayer.add(labelObject);
      }

      if (animation.isActive) {
        animation.func();
      }
    }
  }

  getPanel() {
    const panel = new Panel(this.options.panel);
    panel.onOptionUpdate(this.dispatchOptionUpdate.bind(this));

    var height = 50 - Screw.minSize;
    if (this.options.panel.standOff){
      height = this.options.panel.standOff.value - Screw.minSize;
    }

    if (this.options.panel.isClosed) {
      panel.addFence(height || 1);
    }
    return panel;
  }

  generateScrewGroup() {
    this.screwGroup = new ScrewGroup({
      ...this.options.screw,
      panel: this.options.panel,
      heightOffset: this.is3DMode ? 7 : 0
    });
    this.screwGroup.position.x = this.panel.position.x + this.panel.size.depth / 2;
    
    this.panel.object.addObject(this.screwGroup);

    this.screwGroup.onOptionUpdate(this.dispatchOptionUpdate.bind(this));
    // TODO: Timeout should be removed
    setTimeout(() => {
      const res = this.panel.isObjectOnPanel(this.screwGroup.screws);

      Scene.onUpdate(
        {
          screw: {
            outside: {
              state: !!res.length,
              data: res
            }
          }
        },
        true
      );
    });
  }

  getGround() {
    var globalOptions = this.options;
    if (this.options.panel.type === Panel.types.CIRCLE || 
      (this.options.panel.type === Panel.types.CUSTOM && this.options.panel.vertices.positions.length === 1)) {
        globalOptions = mergeDeep({}, this.options, {panel: { height: this.options.panel.width}});
    } else if (this.options.panel.type === Panel.types.TRIANGLE) {
      globalOptions = mergeDeep({}, this.options, {panel: { center: this.panel.center}});
    }
    
    const ground = new Ground(this.options.ground, this.screwGroup.screwCoordinates, globalOptions);
    ground.onOptionUpdate(this.dispatchOptionUpdate.bind(this));

    ground.position.x = this.panel.position.x - ground.size.depth - this.panel.size.depth / 2;

    if (this.options.screw.heightType === Screw.types.height.INDENTED) {
      ground.position.x -= this.options.panel.standOff.value - Screw.minSize;
    }

    return ground;
  }

  getBeam(options, panel) { // eslint-disable-line class-methods-use-this
    if (!options) throw new Error('Beam options is required');
    if (!panel) throw new Error("Can't find panel object");

    const beam = new Beam({ ...options, panelDepth: panel.options.depth });
    var center = getCenterOfPoints(panel.options.vertices.positions);
    if (!this.is2DEditorMode) {
      if (panel.options.type === Panel.types.CUSTOM) {
        beam.position.x = center.y;
        beam.position.z = -center.z;
      }
    } else {
      var oldCenter = {
        x: panel.options.center && panel.options.center.x || 0,
        y: panel.options.center && panel.options.center.y || 0
      };
      beam.position.x = oldCenter.x - options.shift.x;
      beam.position.z = -oldCenter.y - options.shift.y;
    }
    try {
      beam.onOptionUpdate(this.dispatchOptionUpdate.bind(this));
      if (!this.is2DEditorMode)
        beam.setShift();
      // if (this.is2DMode) {
      //   const shiftLabels = beam.setShiftLabels();
      //   this.layer2D.htmlLayer.addLayer(shiftLabels.HTMLLayer);
      // }
    } catch (e) {
      console.error(e);
    }

    const position = new THREE.Vector3(
      panel.position.x + panel.size.depth / 2 + beam.size.height / 2,
      panel.position.y,
      panel.position.z
    );

    // if (panel.options.type === Panel.types.TRIANGLE) {
    //   const middle = triangleMiddle(triangleSides(panel.size, new THREE.Vector2(position.y, position.z)));

    //   position.y = middle.x;
    //   position.z = middle.y;
    // }

    beam.mesh.rotation.z = Math.PI / 2;
    beam.mesh.position.x = position.x;
    beam.mesh.position.y = position.y;
    beam.mesh.position.z = position.z;

    return beam;
  }

  getHeightLabel(options) {
    const height = this.options.panel.standOff.value - Screw.minSize;

    let position = null;
    if (this.options.panel.type === Panel.types.CUSTOM) {
      let panelEndpoints = getEndpoints(this.options.panel.vertices.positions);
      position = new THREE.Vector3(
        -height - this.panel.size.depth / 2,
        panelEndpoints.top.y,
        -panelEndpoints.top.z
      );
    } else {
      position = new THREE.Vector3(
        -height - this.panel.size.depth / 2,
        this.panel.panel.position.y + this.panel.size.width / 2,
        this.panel.panel.position.z + this.panel.size.height / 2
      );
    }

    if (this.panel.options.type === Panel.types.CIRCLE) {
      position.z = 0;
    }

    const arrow = new Arrow({
      position,
      size: height,
      arrowSize: 10
    });

    let text = ((!options || !options.is3DMode || options.showLabels) ? `${APP_TEXTS.DIMENSION_L.Content} ` : "") +
              `${unitTransform(this.options.panel.standOff ? +this.options.panel.standOff.value : 1)
                .from(defaultUnits.DISTANCE).to(Scene.units.distance)}`;
    const label = new HTMLEditableLabel({
      text,
      value: (this.options.panel.standOff && 
        unitTransform(+this.options.panel.standOff.value).from(defaultUnits.DISTANCE).to(Scene.units.distance)) || 1,
      verticalAlign: HTMLEditableLabel.types.verticalAlign.CENTER
    });
    label.onInputChange((value, didChange) => {
      this.dispatchOptionUpdate({
        panel: {
          standOff: {
            value: +value < 1 ? 1 : unitTransform(+value, false).from(Scene.units.distance).to(defaultUnits.DISTANCE)
          }
        }
      },
      false,
      didChange);
    });
    label.position.set(position.z, position.x + (height / 2), position.y);

    return {
      arrow,
      label
    };
  }

}

function createCurveArrow(direction, isClockwise, shift = 100, color, position) {
  const arrow = new ArrowCurve({
    size: 30,
    color: color || 0xff0000,
    direction,
    isClockwise,
    shift: shift,
    position
  });

  arrow.object.position.set(position.x, position.y, position.z); // for cone and lines

  // Arrow
  const LINE = 0;
  arrow.mesh.children[0].children[LINE].material.depthTest = false;
  const CONUS = 1;
  arrow.mesh.children[0].children[CONUS].material.depthTest = false;

  // Dashed line
  if (arrow.mesh.children[1])
    arrow.mesh.children[1].material.depthTest = false;

  return arrow;
}

function createDashedLine(startPos, endPos, color) {
  let line = new Line({
    from: startPos,
    to: endPos,
    disableDepthTest: true,
    dashed: true,
    customMaterial: new THREE.LineDashedMaterial({
      color,
      linewidth: 1,
      scale: 1,
      dashSize: 6,
      gapSize: 5
    })
  });
  return line;
}



// WEBPACK FOOTER //
// ./src/object-view/generators/general-calculation/general-calculation.object.js